export const texto = {
  "regimen": "Régimen",
  "valor_instalacion_total": "Valor de Instalación Total",
  "campo_obligatorio": "Campo Obligatorio",
  "otras_promociones": "Otras Promociones",
  "coordenadas": "Coordenadas",
  "tipo_tarjeta": "Tipo de Tarjeta",
  "condicion_residencia": "Condición de Residencia",
  "sin_condicion_residencia": "El usuario no tiene condición de residencia",
  "email_or_username": "Correo electrónico o usuario",
  "password": "Contraseña",
  "forgot_password": "¿Olvidaste tu contraseña?",
  "sign_in": "Ingresar",
  "session": "Iniciar Sesión",
  "register": "Crear Cuenta",
  "cancel": "¿Ya tienes cuenta?",
  "error_email_or_user": "Ingrese un usuario o correo electrónico válido",
  "error_password": "Ingrese una contraseña",
  "dashboard": "Informe Transaccional",
  "coin": "Moneda",
  "bank": "Instituciones Financieras",
  "transaction": "Transacciones",
  "channel": "Canal de Recaudación",
  "concilacion": "Conciliación",
  "nombre": "Nombre y Apellido",
  "celular": "Celular",
  "telefono": "Teléfono Fijo",
  "other": "Otros",
  "inputs_empty": "Existen campos vacíos",
  "email_not_validate": "Ingrese un correo electrónico válido",
  "code_not_validate": "Ingrese un código de 6 caracteres",
  "num_count": "Número de Cuenta",
  "name_bank": "Nombre del Banco",
  "email": "Correo electrónico",
  "siglas": "Siglas",
  "code": "Código",
  "filter": "Filtrar Búsqueda",
  "date": "Fecha",
  "sequence_transacction": "Secuencia de Transacción",
  "type_transacction": "Tipo de Transacción",
  "total_recaudado": "Total Recaudado",
  "total_transaction": "Total de Transacciones",
  "ultimate_transacction": "Últimas Transacciones",
  "list_empty": "No hay elementos que coinciden con el filtro",
  "view_report_year": "Ver Informe Anual",
  "hide_year": "Ocultar Informe Anual",
  "version": "Versión 0.0.1",
  "cobranza": "Cobranza",
  "firma_adendum": "Firma Adéndum",
  "contabilidad": "Contabilidad",
  "finanza": "Finanzas",
  "inventario": "Inventario",
  "marketing": "Marketing",
  "rrhh": "RRHH",
  "legal": "Legal",
  "client": "Clientes",
  "admin": "Administración",
  "gestion_empresarial": "Gestion Empresarial",
  "usuarios": "Usuarios",
  "usuario": "Usuario",
  "datos_empresa": "Datos Empresas",
  "parametros_productos": "Productos",
  "parametros_contables": "Contable",
  "parametros_facturacion": "Facturación",
  "parametros_facturacion_electronica": "Facturación Electrónica",
  "parametros_smtp": "SMTP",
  "sucursales": "Sucursales",
  "logs_sistema": "Logs del Sistema",
  "fiscal": "Fiscal",
  "comercial": "Comercial",
  "prospecto": "Prospecto",
  "preventa": "Preventas",
  "agendamientos": "Agendamientos",
  "rechazadas": "Rechazado",
  "cancelado": "Fallido",
  "finalizado": "Finalizado",
  "actualizadas": "Actualizadas",
  "reagendada": "Reagendado",
  "espera_reagendado": "Espera Reagendado",
  "instalaciones": "Instalaciones",
  "instalacion": "Instalación",
  "asignadas": "Asignada",
  "realizadas": "Realizado",
  "ventas": "Ventas",
  "operation": "Operaciones",
  "cambios_domicilio": "Cambio de Domicilio",
  "migraciones": "Migraciones",
  "retiros": "Retiros",
  "tecnico": "Técnico",
  "activaciones": "Activaciones",
  "pendiente": "Pendientes",
  "gestionadas": "Gestionadas",
  "cheques_posfechados": "Cheques Posfechados",
  "cuentas_por_cobrar": "Cuentas por Cobrar",
  "cobros_realizados": "Cobros Realizados",
  "listado_cuotas": "Listado cuotas",
  "comisones_vendedores": "Comisones de Vendedores",
  "compras_adquisiciones": "Compras",
  "compras": "Compras",
  "proveedores": "Proveedores",
  "orden_compra": "Orden Compra",
  "recepcion_compra": "Recepción Compra",
  "grupo_proveedores": "Grupo Proveedores",
  "productos": "Productos",
  "sub_categorias": "Sub Categorías",
  "servicios": "Servicios",
  "servicio": "Servicio",
  "recaudaciones": "Recaudaciones",
  "pagos": "Pagos",
  "modelo_productos": "Modelo Productos",
  "medidas": "Medidas",
  "categorias_productos": "Categorías Productos",
  "kardex": "Kardex",
  "bodegas": "Bodegas",
  "ubicaciones": "Ubicaciones",
  "movimientos_inventario": "Movimientos Inventario",
  "toma_fisica": "Toma Física",
  "ingresos": "Ingresos",
  "salidas": "Salidas",
  "transferencias": "Transferencias",
  "aprobacion_transferencias": "Aprobación Transferencias",
  "activos": "Activos",
  "departamentos": "Departamentos",
  "grupos": "Grupos",
  "responsables": "Responsables",
  "asignaciones": "Asignaciones",
  "mantenimientos": "Mantenimientos",
  "plan_cuenta": "Plan de Cuenta",
  "libro_diario": "Libro Diario",
  "mayores_contables": "Mayores Contables",
  "conciliacion_bancaria": "Conciliación Bancaria",
  "asiento_cierre": "Asiento Cierre",
  "generar_ats": "Generar ATS",
  "retenciones_sri": "Retenciones SRI",
  "bloqueo_periodos": "Bloqueo de Periodos",
  "activos_fijos": "Activos Fijos",
  "cartera": "Cartera",
  "colaboradores": "Colaboradores",
  "nomina": "Nómina",
  "cargos": "Cargos",
  "rubros": "Rubros",
  "prestamos": "Prestamos",
  "rol_general": "Rol General",
  "pago_nomina": "Pago Nómina",
  "descuento_lotes": "Descuento Lotes",
  "liquidacion_prestamos": "Liquidación Prestamos",
  "pago_anticipo_lotes": "Pago Anticipado por Lotes",
  "gerencia": "Gerencia",
  "informes": "Informes",
  "reporteria": "Reportería",
  "ordenes_trabajo": "Orden de Trabajo",
  "registro_orden_trabajo": "Registro Orden de Trabajo",
  "traslados": "Traslados",
  "visitas": "Visitas",
  "proformas": "Proformas",
  "pedidos": "Pedidos",
  "autorizar_documento": "Autorizar Documento",
  "secuencia_documentos": "Secuencia Documnetos",
  "facturacion_lotes": "Facturación por Lotes",
  "tarjetas_credito": "Tarjetas de Crédito",
  "ingresar_num_tarjeta": "Ingresar Número de Tarjeta",
  "telefono_fijo": "Teléfono Adicional",
  "telefono_movil": "Teléfono Movil",
  "persona_referido": "Referido",
  "persona_referencia": "Referencia",
  "celular_referencia": "Celular Referencia",
  "telefono_fijo_referencia": "Teléfono Adicional Referencia",
  "telefono_adicional": "Teléfono Adicional",
  "detalle_instalacion": "Detalle Instalación",
  "velocidad_internet": "Velocidad Internet",
  "valor_instalacion": "Valor Instalación",
  "valor_instalacion_sin_iva": "Valor Instalación Sin IVA",
  "valor_instalacion_con_iva": "Valor Instalación Con IVA",
  "router": "Router",
  "valor_router": "Valor Router",
  "valor_total_instalacion": "Valor Total Instalación",
  "equipo_adicional": "Equipo Adicional",
  "numero_cuotas": "Número de Cuotas",
  "requiere_promocion": "Requiere Promoción",
  "respaldo_pago": "Documento de Cuenta Bancaria",
  "cargar_cedula": "Cédula Frontal",
  "cargar_cedula_reverso": "Cédula Reverso",
  "numero_cuenta": "Número Cuenta",
  "foto_tarjeta": "Foto del Número de Tarjeta",
  "nap": "NAP",
  "distancia_aproximada": "Distancia Aproximada",
  "requiere_router_ac": "Requiere Router AC",
  "dispone_regulador": "Dispone Regulador",
  "foto_aceptacion_cliente": "Foto Aceptación Cliente",
  "tipo_servicio": "Tipo Servicio",
  "tipo_plan": "Tipo Plan",
  "plan": "Plan",
  "tipo_instalacion": "Tipo Instalación",
  "tipo_documento": "Tipo de Documento",
  "none_document": "No hay ningún registro con el número de identificación ingresado",
  "observacion": "Observación",
  "fecha_nacimiento": "Fecha Nacimiento",
  "edad": "Edad",
  "city": "Ciudad",
  "zona": "Zona",
  "sector": "Sector",
  "nombre_apellido": "Nombres y Apellidos",
  "detalle_servicio": "Detalle Valores de Servicio",
  "forma_pago": "Forma de Pago",
  "identificacion": "Identificación",
  "identificacion_condicion_venta": "Identificación de Solicitud Evento/Canje",
  "plan_internet": "Plan de Internet",
  "promocion_adicional": "Promoción Adicional",
  "costo_instalacion": "Costo de Instalación",
  "costo_instalacion_sin_iva": "Costo de Instalación Sin IVA",
  "otros_cargos": "Otros Cargos",
  "documentos": "Documento",
  "nacionalidad": "Nacionalidad",
  "informacion_personal": "Información Cliente",
  "informacion_corporativo": "Información Corporativo",
  "informacion": "Información",
  "informacion_referencia": "Información Referencia",
  "system_settings_txt": "Configuración del Sistema",
  "documents_type_txt": "Tipos de Documentos",
  "promociones_txt": "Promociones",
  "payment_method_txt": "Métodos de Pago",
  "recurrencia_txt": "Recurrencia",
  "direccion": "Dirección",
  "entidad_finciera": "Entidad Finaciera",
  "tipo_cuenta": "Tipo de Cuenta",
  "cooperativa": "Cooperativa",
  "parroquia": "Parroquia",
  "edad_no_permitida": "No esta en el rango de edad permitido",
  "no_residencia": "La persona no cumple con la condición de residencia definitiva.",
  "derechos_perdidos": "La persona consta con perdida de derechos.",
  "datos_contacto": "Información de Contacto",
  "contacto_cliente": "Contacto Cliente",
  "contacto_referencia": "Contacto Refencia",
  "datos_buros": "Datos Buró",
  "detalle_encuesta": "Detalle Encuesta",
  "detalle_valores_servicio": "Detalle Valores Servicio",
  "latitud": "Latitud",
  "longitud": "Longuitud",
  "segmentacion": "Segmentación",
  "puntaje_empresa": "Puntaje Empresa",
  "flota": "Flota",
  "como_se_entero": "¿Como se enteró del servicio?",
  "herramienta_utilizada": "¿Herramienta Utilizada?",
  "tipo_vivienda": "Tipo de Vivienda",
  "numero_pisos": "Número de Pisos",
  "numero_dispositivos": "Número de Dispositivos",
  "tipo_uso": "Tipo de Uso",
  "crear_preagendamiento": "Crear Preagendamiento",
  "puntaje_score": "Puntaje score",
  "puntaje_score_sobreendeudamiento": "Puntaje Score Sobreendeudamiento",
  "puntaje_score_empresa": "Puntaje Score Empresa",
  "pais": "País",
  "observacion_1": "APLICA PARA TODAS LAS CIUDADES",
  "observacion_2": "observacion_2",
  "cantidad": "Cantidad",
  "tipo_parentesco": "Parentesco",
  "valor_plan": "Valor del Plan",
  "agendadas": "Agendado",
  "sin_cobertura_provincia": "Sin cobertura para la provincia, ingresar manualmente",
  "sin_cobertura_ciudad": "Sin cobertura para la ciudad, ingresar manualmente",
  "preagendamiento": "Pre Agendadas",
  "espera": "En Espera",
  "disponible": "Disponible",
  "persona_tercera_edad": "Persona de Tercera Edad",
  "persona_con_discapacidad": "Persona con Discapacidad",
  "persona_sin_discapacidad": "Persona no registra Discapacidad",
  "provincia": "Provincia",
  "ciudad": "Ciudad",
  "documentos_incompletos": "Documentos Incompletos",
  "solicitud_pedido_espera": "Solicitudes en espera",
  "solicitudes_pedido_aprobadas": "Solicitudes aprobadas",
  "aprobado_pendiente_abierto": "Solicitudes de pedidos abiertas",
  "solicitud_pedido_rechazada": "Solicitudes rechazadas",
  "solicitud_pedido_rechazada_parcialmente": "Solicitudes rechazadas parcialmente ",
  "solicitud_pedido_finalizada": "Solicitudes finalizadas",
  "solicitud_espera": "Solicitudes en espera",
  "solicitudes_aprobadas": "Solicitudes aprobadas",
  "solicitud_rechazada": "Solicitudes rechazadas",
  "tickets_espera": "Tickets en espera",
  "tickets_aprobadas": "Tickets aprobadas",
  "tickets_en_proceso": "Tickets en proceso",
  "tickets_rechazada": "Tickets rechazadas",
  "solicitud_despachadas": "Solicitudes de pedidos aprobadas parciales",
  "ordenes_espera": "Órdenes de compra en espera",
  "ordenes_aprobadas": "Órdenes de compra finalizados",
  "ordenes_abierta": "Órdenes de compra abierta",
  "ordenes_parcial": "Órdenes de Compra con Cierre Parcial",
  "ordenes_rechazada": "Órdenes de compra Rechazados",
  "ordenes_finalizada": "Órdenes de compra Finalizados",
  "servicios_espera": "Servicios en espera",
  "servicios_aprobados": "Servicios aprobados",
  "servicios_rechazados": "Servicios rechazados",
  "equipos_adicionales": "Equipos Adicionales",
  "cliente_refiere": "Cliente Refiere",
  "empleado_refiere": "Empleado Refiere",
  "cedula_cliente_refiere": "Cédula Cliente Refiere",
  "cedula_empleado_refiere": "Cédula Empleado Refiere",
  "telefono_cliente_refiere": "Teléfono Cliente Refiere",
  "telefono_empleado_refiere": "Teléfono Empleado Refiere",
  "direccion_cliente_refiere": "Dirección Cliente Refiere",
  "direccion_empleado_refiere": "Dirección Empleado Refiere",
  "aprobado": "Aprobado",
  "solicitud": "Solicitudes",
  "flota_refiere": "Flota Referencia",
  "cargos_adicionales": "Otros Cargos",
  "localidad": "Residencia",
  "codigo": "Código",
  "codigo_secundario": "Código Secundario",
  "presentacion": "Presentación",
  "codigo_barras": "Código de Barras",
  "descripcion": "Descripción",
  "existencia_actual": "Stock Actual",
  "costo_actual": "Costo Actual",
  "costo_compra": "Costo Compra",
  "costo_promedio": "Costo Promedio",
  "stock_maximo": "Stock Máximo",
  "stock_minimo": "Stock Mínimo",
  "stock_seguridad": "Stock Seguridad",
  "cuentas_relacionadas": "Cuentas Relacionadas",
  "series": "Series",
  "categoria_producto": "Categoría Producto",
  "subcategoria_producto": "Subcategoria Producto",
  "grupo_producto": "Grupo Producto",
  "tipo_producto": "Tipo Producto",
  "iva": "IVA",
  "unidad_producto": "Unidad Producto",
  "cuenta_contable": "Cuenta Contable",
  "marca_producto": "Marca Producto",
  "modelo_producto": "Modelo Producto",
  "bodega": "Bodega",
  "bodega_destino": "Bodega Destino",
  "bodega_origen": "Bodega Origen",
  "ubicacion_origen": "Ubicación Origen",
  "ubicacion_destino": "Ubicación Destino",
  "ubicacion_externa": "Ubicación Externa",
  "imagen_producto_1": "Imagen 1",
  "imagen_producto_2": "Imagen 2",
  "ficha_tecnica": "Ficha Técnica",
  "recurrencia_compra": "Recurrencia Compra",
  "acepta_negativos": "Acepta Negativos",
  "precio_1": "Precio 1",
  "precio_2": "Precio 2",
  "precio_3": "Precio 3",
  "precio_4": "Precio 4",
  "proveedor": "Proveedor",
  "campos_obligatorios": "Campos Obligatorios sin Llenar",
  "producto_activo": "Producto Activo",
  "error_generar_reporte": "Error al Generar el Reporte",
  "estado": "Estado",
  "cuenta": "Nombre de la Cuenta",
  "generales": "Generales",
  "compra_venta": "Compra y Ventas",
  "cobros": "Cobros",
  "caja_banco": "Caja y Banco",
  "informacion_equifax": "Información de Equifax",
  "solicitud_beneficio": "Solicitud Beneficio Prospecto",
  "ced_beneficio_tutordiscapacidad": "Cédula de Persona con Discapacidad",
  "pago_plan": "Pago y Plan",
  "promocion": "Promoción",
  "generar_serie": "Generar Serie",
  "numero_movimiento": "Número de Movimiento",
  "fecha_creacion": "Fecha de Creación",
  "fecha_documento": "Fecha Solicitud",
  "unidad_transporte": "Unidad de Transporte",
  "motivo": "Motivo",
  "seleccionar": "Seleccionar",
  "fecha_transferencia": "Fecha de Transferencia",
  "sin_productos_agregados": "No hay items agregados",
  "transferido": "Transferido",
  "es_para_venta": "Es para Venta",
  "transferencia_inventario": "Transferencia de Inventario",
  "solicitud_transferencia": "Solicitud de Transferencia",
  "equipo_adicional_existente": "Ya existe un equipo adicional con el mismo nombre",
  "metodo_aceptacion": "Metódo de Aceptación",
  "documento_personal": "Documentos Personales",
  "terminos_condiciones": "Acepto términos y Condiciones",
  "pendiente_pago": "PENDIENTE PAGO",
  "instalacion_gratis": "INSTALACIÓN GRATIS",
  "comprobante_pago": "Comprobante Pago",
  "revision_comprobante": "Comprobante de Pago",
  "datos_usuario": "Datos del Usuario",
  "coordenadas_usuario": "Coordenadas del Usuario",
  "verificar_numero": "Verificar Número",
  "otp": "OTP",
  "sin_plan_tercerdad_dicapacitado": "No hay plan para personas de tercera edad o con discapacidad",
  "ingresar": "Ingresar",
  "clave": "Contraseña",
  "recepcion_mercaderia": "Recepción Mercadería",
  "fecha_solicitud_transferencia": "Fecha de Solicitud",
  "debito_cuenta": "Débito de Cuenta",
  "seleccionar_ubicacion": "Seleccionar Ubicación",
  "tipo_contrato": "Tipo de Contrato",
  "ubicacion_sin_producto": "Ubicación origen no contiene productos",
  "cedula_refiere": "Cédula del Cliente Refiere",
  "transferencia_misma_bodega": "No es posible hacer una transferencia a la misma ubicación",
  "fecha_hora_calendario": "Fecha y hora de instalación",
  "tecnicos_disponibles": "Técnicos disponibles",
  "promocion_3": "Promoción 3",
  "promocion_2": "Promoción 2",
  "es_fibra": "Es Fibra",
  "es_utp": "Es UTP",
  "es_ont": "Es ONT",
  "limite_stock_actual": "La cantidad excede al límite del stock actual",
  "selecionar_series": "Selecionar método para cargar series.",
  "series_no_igual_cantidad": "La cantidad de series no coincide con lo que se solicitó.",
  "error_imagen_cedula": "Subir una cédula valida, no se pudo extraer el texto de la cédula o no se reconoce la inscripcion de ECUADOR en la cédula.",
  "cliente_sin_firmar": "Por favor, espera a que el cliente firme el contrato para continuar con el proceso.",
  "tipo_referido": "Tipo de Referido",
  "aceptar": "Aceptado",
  "acceso_denegado_403": "Acceso denegado. No cumples con los permisos necesarios: [403]",
  "historial": "Historial",
  "tipo_contribuyente": "Tipo Contribuyente",
  "sin_plan_residencia": "Por favor, complete la información de residencia y seleccione una forma de pago para visualizar los planes disponibles.",
  "mensaje_bloquar_horario": "Una vez seleccione esta hora, no podrá cambiarla durante 1 minuto, y el horario se bloqueará durante ese tiempo.",
  "mensaje_bloquar_horario_10_min": "Una vez seleccione esta hora, no podrá cambiarla durante 10 minutos. La instalación tiene un minimo de 2 horas y 30 minutos.",
  "flota_seleccion": "Por favor, selecciona un técnico para la instalación.",
  "flota_sin_planificacion": "Por favor, selecciona un técnico para la instalación. Si no hay disponibilidad, comunícate con soporte o el departamento correspondiente para obtener asistencia.",
  "nota_correo_valido": "Nota: Asegúrese de ingresar un correo electrónico activo para el envío del contrato.",
  "hora_min_planificacion": "NOTA: Una instalación debe durar al menos 2 horas y 30 minutos. La hora seleccionada no cumple con este requisito.",
  "hora_ocupada": "Parece que alguien más está ocupando esta hora. Por favor, intente con otra opción.",
  "no_informacion_equifax": "Por motivos de seguridad, Equifax ha restringido los datos de la persona. Esto no afectará el proceso, puede continuar con la venta.",
  "selecion_hora_calendario": "Parece que alguien más ya seleccionó esta hora.",
  "hora_preselecionada_ventas": "Se encontró que la hora de instalación seleccionada coincide con una hora preseleccionada. Una vez que selecciones esta hora, no podrás cambiarla durante 1 minuto, y el horario se bloqueará durante ese tiempo. ¿Seguro quieres agendar la instalación en este horario?",
  "bitacora": `Comienzo`,
  "lorem": "Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto. Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año 1500.",
  "solicitud_extranjero": "Se ha detectado que el cliente tiene residencia temporal. Para continuar con el servicio, se necesita la aprobación del supervisor de ventas. ¿Deseas crear una solicitud de venta para extranjero?",
  "categoria_incidente":`Categoría incidente`,
  "subcategoria_incidente":`Subcategoría incidente`,

  "permiso_ubicacion": `EVA necesita acceder permisos de ubicación para obtener las coordenadas actual. Tu información solo se usará para este propósito.`,
  "plan_3edad_disc": `Nota: Por disposición oficial, el plan correspondiente a solicitudes con de "TERCERA EDAD" o "DISCAPACIDAD" se asigna automáticamente.`,
  "plan_curador_tutor": `Nota: Por disposición oficial, el plan correspondiente a solicitudes con"FAMILIAR CON DISCAPACIDAD" se asigna automáticamente.`,
  "plan_bono_desarrollo_humano": `Nota: Por disposición oficial, el plan correspondiente a solicitudes con"BONO DE DESARROLLO HUMANO" se asigna automáticamente.`,
  "plan_ayuda_social": `Nota: Por disposición oficial, el plan correspondiente a solicitudes con"AYUDA SOCIAL" se asigna automáticamente.`,
  "egreso_sin_stock": "El producto solicitado no tiene stock disponible. Por favor, espere hasta que el stock sea suficiente.",
  "progress_circular": "Cargando... Por favor espera, estaremos listos en un momento.",
  "trasferencia_prodcutoIncompleto": "Se encontraron",
  "egreso_productoIncompletosEn_ubicacion": "Lo sentimos: Los productos que buscas no existen en esta ubicación. Elija otra ubicacion o solicite un ingreso de inventario",
  //"egreso_productoIncompletosEn_ubicacion": "productos no disponibles en la ubicación seleccionada.",
  //"egreso_productoIncompletosEn_ubicacion": "Algunos productos solicitados no se encontraron. Por favor, verifique que todos los productos estén disponible en la ubicacion seleccionada. Caso contrario genere un traslado o ingreso.",
  "egreso_title": "Ooops lo sentimos !",
  "egreso_ubicacion": "y en la bodega",
  "egreso_alerta": "No hemos encontrado productos en la ubicación:",
  "egreso_NoExiste_producto": "Le sugerimos generar un ingreso o traslado de productos, o intentar buscar en otra ubicación. Por el momento, no es posible realizar el despacho.",
  "transito_inventario": "Proceder con el envío de la transferencia en tránsito. Este proceso implica el movimiento de inventario y debe ser gestionado con precisión. Por favor, verifica todos los detalles antes de continuar.",
  "notificacion_es_bras":"Esta OLT utiliza esquema BRAS",
  "notificacion_es_router":"Esta OLT utiliza esquema router, por lo tanto se asignó el router correspondiente.",
  "notificacion_grupoipv4_router":"Este Grupo IPV4 ya fue asignado a un router.",
  "gateway_no_valido":"El Gateway ingresado no es válido. Debe ser una dirección IPv4 válida y su último octeto ser 1.",
  "orden_trabajo_no_iniciada":"La orden de trabajo aún no se encuentra iniciada por el técnico.",
  "orden_trabajo_iniciada":"Orden de trabajo iniciada. Complete la información para continuar.",
  "plan_gremio": `Nota: Por disposición oficial, el plan correspondiente a solicitudes con "APLICA GREMIO" se asigna automáticamente.`,
  "correccion_solicitada_tecnico_auditoria": "Corrección solicitada por el área de auditoría. A continuación los detalles de la petición.",
  "verifique_ont_tecnico":"Verifique que la ONT física coincida con la asignada en el sistema antes de continuar.",
  "verifique_coordenadas_tecnico":"Confirme que las coordenadas capturadas corresponden al punto real de instalación.",
  "advertencia_nap_puerto_ocupado_activaciones":"Actualmente este puerto esta asociado a otro cliente, realizar esta acción sobreescribirá la información de la activación actual. Se recomienda validar físicamente el puerto. ¿Está seguro que desea continuar?",
  "advertencia_nap_puerto_disponible_activaciones":"Este puerto se encuentra disponible para realizar la activación. Se habilitará el puerto asignado automáticamente y se asignará el seleccionado. ¿Está seguro que desea continuar?",
  "advertencia_cambio_router":"Realizar esta acción sobreescribirá la información de configuración de red actual y se asignará una nueva IPv4 para el cliente. ¿Está seguro que desea continuar?",
  "olt_migrada":"Se realizará la activación de manera automática.",
  "olt_no_migrada":"Proceda con la activación de manera manual.",
  "instalacion_en_curso_tecnico":"A continuación, será redirigido a la instalación en curso. ¿Desea continuar?",
}
